import {IColumn} from 'models';

export const paperAssessmentsColumns = [
  {id: 'name', label: 'Name'},
  {id: 'uploadedBy', label: 'Uploaded By'},
  {id: 'actions', label: '', align: 'right'},
] as IColumn[];
